<template>
  <div class="dispatch-map">
    <div class="map-box">
      <div id="container"></div>
      <div class="map-center-box">
        <div class="chatting">
          <van-loading size="14" v-if="getCenterLoading">加载中...</van-loading>
          <span v-else>{{mapCenterInfo.title}}</span>
        </div>
        <van-image width="30" height="39" :src="require(queryParams.type&&queryParams.type=='start'?'/src/assets/image/nanhang-start-address.png':'/src/assets/image/nanhang-end-address.png')" />
      </div>
      <!-- 提示框 -->
      <div class="prompt-dialog-box">
        <div class="iconfont" style="margin-right:10px;font-size:12px;">&#xe638;</div>
        <div>请确认收货地址是否准确，如不准确请拖动地图进行调整</div>
        <!-- <div class="bottom"></div> -->
      </div>
      <div :class="{'position-phone':true,'position-phone-active':isPositionPhone}" @click="handlePanToPositionPhone">
        <div class="van-button">
          <div class="dot"></div>
        </div>
      </div>
      <!--  <div class="watch-position">
        {{`${watchPositionInfo.lat},${watchPositionInfo.lng}`}}
      </div> -->
    </div>
    <address-info ref="addressInfo" :mapLoaded="mapLoaded" :mapCenterInfo="mapCenterInfo" :checkAddressObject="checkAddressObject" :openSearch.sync="openSearch" :getCenterLoading="getCenterLoading" :queryParams.sync="queryParams" />
    <search-list ref="searchList" :map="map" :locationPhoneInfo.sync="locationPhoneInfo" :showIdentification.sync="showIdentification" :getCenterLoading.sync="getCenterLoading" :mapCenterInfo.sync="mapCenterInfo" :openSearch.sync="openSearch" :queryParams="queryParams" @openCitySelected="openCitySelected" @getMapCenter="getMapCenter" />
    <address-identification :showIdentification.sync="showIdentification" ref="addressIdentification" @confirm="identificationConfirm" />
    <city-selected :locationPhoneInfo="locationPhoneInfo" ref="citySelected" :mapCenterInfo="mapCenterInfo" :map="map" @getMapCenter="getMapCenter" @confirm="handleCityConfirm" />
  </div>
</template>

<script>
// var receiveMessage = function(msg){
// }
// window.addEventListener("message", receiveMessage, false);
import { geocoder } from '@/api/dispatch/index.js';
import addressInfo from './components/address-info.vue';
import searchList from './components/search-list.vue';
import addressIdentification from './components/address-identification.vue';
import { Image, Loading, Search } from 'vant';
import CitySelected from './components/city-selected.vue';
import permission from '@/utils/permission.js'
import Vconsole from 'vconsole';

export default {
  components: {
    addressInfo,
    searchList,
    addressIdentification,
    CitySelected,
    [Image.name]: Image,
    [Loading.name]: Loading,
    [Search.name]: Search,
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      // 用来判断是否是修改卸货地，如果是修改卸货地的，直接跳回应用计算价格，否则就返回上一页
      if (/\/beecargo\/logisticsDetails/.test(from.path)) {
        vm.isSwitchTab = true;
      } else {
        vm.isSwitchTab = false;
      }
    });
  },
  data() {
    return {
      map: null,
      mapZoomAntiShakeTimer: null,  //地图缩放防抖计时器
      mapCenterInfo: {},  //当前地图中心数据
      getCenterLoading: false,  //获取中心点loading
      openSearch: false,  //地址搜索栏
      showIdentification: false,  //显示地址识别框
      //手机当前位置
      locationPhoneInfo: {
        province: '',  //省
        city: '',  //市
        district: '',  //区
        detailedAddress: '',  //详细地址
        title: '',  //标题
        latitude: '',
        longitude: '',
      },
      queryParams: {
        id: null,
        province: '',
        city: '',
        district: '',
        detailedAddress: '',
        phoneNumber: '',
        realName: '',
        remark: '',
        title: '',
        latitude: '',
        longitude: '',
        type: 'start'
      },
      mapLoaded: false,  //地图加载完毕(瓦片全部显示)
      watchPositionInfo: {},
      mapPanendSource: '',  //地图平移操作来源
      isSwitchTab:false,//是否是跳转到uniapp应用
      checkAddressObject:{},//存储检查卸货地是否是同一个卸货地
    }
  },
  watch: {
    mapCenterInfo: {
      handler(val) {
        Object.assign(this.queryParams, val);
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    isPositionPhone() {
      return (this.mapCenterInfo.latitude == this.locationPhoneInfo.latitude && this.mapCenterInfo.longitude == this.locationPhoneInfo.longitude)
        && (this.locationPhoneInfo.latitude != '22.543099' && this.locationPhoneInfo.longitude != '114.057868');
    }
  },
  beforeCreate() {
    let pagesTital = '';
    let query = this.$route.query;
    // if(query.id) pagesTital = `编辑${query.type==1?'装货地':'卸货地'}`;
    // else pagesTital = `新增${query.type==1?'装货地':'卸货地'}`;
    if (query.id) pagesTital = `编辑${query.type == 'start' ? '装货地' : '卸货地'}`;
    else pagesTital = `新增${query.type == 'start' ? '装货地' : '卸货地'}`;
    document.title = pagesTital;
  },
  created() {
    let vConsole;
    if (process.env.NODE_ENV === 'development') vConsole = new Vconsole();
    this.initData();
    this.handlePlusReady();
    // 扩展API是否准备好，如果没有则监听“plusready"事件
    if (window.plus) {
      this.handlePlusReady()
    } else {
      document.addEventListener('plusready', this.handlePlusReady, false)
    }
  },
  mounted() {
    this.createMap()
      .then(() => this.initMap());
    this.createGeolocation()
      .then(() => this.handleGetLocation)
  },
  beforeDestroy() {
    // this.clearWatch();
  },
  methods: {
    async handlePlusReady() {
      await this.createGeolocation();
      console.log('当前获取到的query', this.$route.query)
      if (this.$route.query.locationPhoneLat && this.$route.query.locationPhoneLng) {
        let options = this.$route.query.id ? { notSetCenterInfo: true } : { LatLng: { lat: this.$route.query.locationPhoneLat, lng: this.$route.query.locationPhoneLng } }
        let result = await this.getMapCenter(options)
        this.locationPhoneInfo = {
          province: result.address_component.province,  //省
          city: result.address_component.city,  //市
          district: result.address_component.district,  //区
          detailedAddress: result.pois[0].address,  //详细地址
          title: result.pois[0].title,  //标题
          latitude: result.location.lat,
          longitude: result.location.lng,
        }
      } else {
        // 获取定位权限状态
        permission.appPermission({ iosKey: 'location', androidKey: 'ACCESS_FINE_LOCATION' })
          .then(PermissionResult => {
            console.log('位置权限成功开启', JSON.stringify(PermissionResult));
            /* this.watchPosition()
            .then(position=>this.watchPositionInfo = position); */
            this.handleGetLocation()
              .then(async position => {
                let { result: geocoderResult } = await geocoder({ location: `${position.lat},${position.lng}`, get_poi: 1, poi_options: 'policy=2' });
                this.locationPhoneInfo = {
                  province: geocoderResult.address_component.province,  //省
                  city: geocoderResult.address_component.city,  //市
                  district: geocoderResult.address_component.district,  //区
                  detailedAddress: geocoderResult.pois[0].address,  //详细地址
                  title: geocoderResult.pois[0].title,  //标题
                  latitude: geocoderResult.location.lat,
                  longitude: geocoderResult.location.lng,
                }
              })
              .catch(err => {
                console.log('位置信息获取失败', JSON.stringify(err));
              })
          })
          .catch(err => {
            console.log('位置权限开启失败', JSON.stringify(err))
          })
      }
    },
    /* 城市选择确认
     * 调用搜索列表的搜索功能
     */
    handleCityConfirm() {
      this.$refs['searchList'].handleQuery();
    },
    /* 打开城市选择弹框 */
    openCitySelected() {
      this.$refs['citySelected'].show = true;
    },
    /** 数据初始化 */
    initData() {
      let query = this.$route.query;
      this.checkAddressObject = this.deepClone(query);
      this.queryParams = {
        id: query.id ? query.id : null,
        phoneNumber: query.phoneNumber ? query.phoneNumber : '',
        realName: query.realName ? query.realName : '',
        remark: query.remark ? query.remark : '',
        type: query.type ? query.type : null,
        pagesType: query.pagesType ? query.pagesType : '',
        selected: query.selected && !isNaN(query.selected) ? (+query.selected ? true : false) : false,
      };
      this.mapCenterInfo = {
        province: query.province ? query.province : '',
        city: query.city ? query.city : '',
        district: query.district ? query.district : '',
        detailedAddress: query.detailedAddress ? query.detailedAddress : '',
        title: query.title ? query.title : '',
        latitude: query.latitude ? query.latitude : '',
        longitude: query.longitude ? query.longitude : '',
      };
    },
    /** 地址识别确认 */
    identificationConfirm(params) {
      Object.assign(this.queryParams, {
        realName: params.realName,
        phoneNumber: params.phoneNumber,
        remark: params.remark
      })
      this.openSearch = true;
      this.$nextTick(() => {
        this.$refs['searchList'].searchValue = params.detailedAddress.replace(/\s/g, '');
        this.$refs['searchList'].getList();
      })
    },
    async initMap() {
      if (this.map) return;
      let query = this.$route.query;
      let LatLng = {};
      if (query.latitude && query.longitude) LatLng = { latitude: query.latitude, longitude: query.longitude };
      else if (query.locationPhoneLat && query.locationPhoneLng) {
        LatLng = { latitude: query.locationPhoneLat, longitude: query.locationPhoneLng };
      } else LatLng = { latitude: '22.543099', longitude: '114.057868' };
      var center = new window.TMap.LatLng(LatLng.latitude, LatLng.longitude);
      //初始化地图
      this.map = new window.TMap.Map("container", {
        rotation: 0,//设置地图旋转角度
        pitch: 0, //设置俯仰角度（0~45）
        zoom: 17,//设置地图缩放级别
        center: center,//设置地图中心点坐标
      });
      this.map.on('zoom', this.mapZoom);
      this.map.on('panend', this.mapPanend);
      this.map.on('dragend', this.mapDragend);
      this.map.on('tilesloaded', this.mapTilesloaded);
      this.$refs['searchList'].mountPanend(this.map);
      this.$refs['citySelected'].mountPanend(this.map);
      await this.handleSetLocationPhoneInfo();
      if (!this.$route.query.id) this.openSearch = true;
    },
    /* 设置手机当前位置信息
     * 当uni跳转过来时带了手机经纬度则根据经纬度逆地址解析设置相关信息
     * 否则需要当 plusReady 时进行相关权限校验再获取位置信息 
     */
    async handleSetLocationPhoneInfo() {
      if (!(this.$route.query.locationPhoneLat && this.$route.query.locationPhoneLng)) return Promise.resolve();
      try {
        let result = await this.getMapCenter({
          notSetCenterInfo: this.$route.query.id ? true : false,
          LatLng: { lat: this.$route.query.locationPhoneLat, lng: this.$route.query.locationPhoneLng }
        })
        this.locationPhoneInfo = {
          province: result.address_component.province,  //省
          city: result.address_component.city,  //市
          district: result.address_component.district,  //区
          detailedAddress: result.pois[0].address,  //详细地址
          title: result.pois[0].title,  //标题
          latitude: result.location.lat,
          longitude: result.location.lng,
        }
        return Promise.resolve();
      } catch (error) {
        console.log('handleSetLocationPhoneInfo getMapCenter失败', error)
        return Promise.resolve();
      }
    },
    // 地图缩放事件
    mapZoom() {
      if (this.mapZoomAntiShakeTimer) {
        clearTimeout(this.mapZoomAntiShakeTimer);
        this.mapZoomAntiShakeTimer = null;
      }
      this.mapZoomAntiShakeTimer = setTimeout(() => this.getMapCenter(), 200)
    },
    // 地图拖拽交互结束时触发
    mapDragend() {
      this.getMapCenter();
    },
    // 地图平移结束
    mapPanend() {
      switch (this.mapPanendSource) {
        case 'positionPhone':
          if (this.map.getZoom()) this.getMapCenter();
          else this.map.zoomTo(17);
          break;
        default: '';
      }
      this.mapPanendSource = '';
    },
    // 瓦片加载完毕
    mapTilesloaded() {
      this.mapLoaded = true;
      this.map.off('tilesloaded', this.mapTilesloaded);
    },
    async getMapCenter(options) {
      try {
        if (!(options && options.notSetCenterInfo)) this.getCenterLoading = true;
        let lat, lng;
        if (options && options.LatLng) {
          lat = options.LatLng.lat;
          lng = options.LatLng.lng;
        } else {
          let centerData = this.map.getCenter();
          lat = centerData.lat;
          lng = centerData.lng;
        }
        let { result } = await geocoder({ location: `${lat},${lng}`, get_poi: 1, poi_options: 'policy=1' });
        if (options && options.notSetCenterInfo) return Promise.resolve(result);
        if (!result.pois.length) {
          this.mapCenterInfo = {
            province: '',  //省
            city: '',  //市
            district: '',  //区
            detailedAddress: '',  //详细地址
            title: '移动以获取位置',  //标题
            latitude: result.location.lat,
            longitude: result.location.lng,
          };
          return Promise.reject(result)
        }
        this.mapCenterInfo = {
          province: result.address_component.province,  //省
          city: result.address_component.city,  //市
          district: result.address_component.district,  //区
          detailedAddress: result.pois[0].address,  //详细地址
          title: result.pois[0].title,  //标题
          latitude: result.location.lat,
          longitude: result.location.lng,
        };
        this.getCenterLoading = false;
        return Promise.resolve(result)
      } catch (error) {
        this.getCenterLoading = false;
        return Promise.reject(error);
      }
    },
    /* 移动地图中心点至手机当前位置
     */
    handlePanToPositionPhone() {
      if (
        (this.locationPhoneInfo.latitude && this.locationPhoneInfo.latitude)
        && (this.locationPhoneInfo.latitude != '22.543099' && this.locationPhoneInfo.longitude != '114.057868')
      ) {
        this.mapPanendSource = 'positionPhone';
        return this.map.panTo(new window.TMap.LatLng(this.locationPhoneInfo.latitude, this.locationPhoneInfo.longitude));
      }
      permission.appPermission({ iosKey: 'location', androidKey: 'ACCESS_FINE_LOCATION' })
        .then(PermissionResult => {
          this.handleGetLocation()
            .then(async position => {
              if (!position.lat || !position.lng || position.lat == 5e-324 || position.lng == 5e-324) {
                return this.$dialog.confirm({
                  title: '权限提示',
                  message: '请在手机中开启定位信息权限',
                }).then(() => {
                  permission.goSystemAppSetting();
                }, () => { });
              }
              let { result: geocoderResult } = await geocoder({ location: `${position.lat},${position.lng}`, get_poi: 1, poi_options: 'policy=2' });
              this.locationPhoneInfo = {
                province: geocoderResult.address_component.province,  //省
                city: geocoderResult.address_component.city,  //市
                district: geocoderResult.address_component.district,  //区
                detailedAddress: geocoderResult.pois[0].address,  //详细地址
                title: geocoderResult.pois[0].title,  //标题
                latitude: geocoderResult.location.lat,
                longitude: geocoderResult.location.lng,
              };
              this.mapPanendSource = 'positionPhone';
              this.map.panTo(new window.TMap.LatLng(geocoderResult.location.lat, geocoderResult.location.lng));
            })
            .catch(err => {
              console.log('位置信息获取失败', JSON.stringify(err));
              this.$dialog.confirm({
                title: '权限提示',
                message: '请在手机中开启定位信息权限',
              })
                .then(() => {
                  permission.goSystemAppSetting();
                })
                .catch(() => { })
            })
        })
        .catch(err => {
          this.listLoading = false;
          console.log('位置权限开启失败', JSON.stringify(err))
          this.$dialog.confirm({
            title: '权限提示',
            message: '请在手机中开启定位信息权限',
          })
            .then(() => {
              permission.goSystemAppSetting();
            })
            .catch(() => { })
        })

    },
  }
}
</script>

<style scoped lang="scss">
::v-deep .mask-style {
  z-index: 9998 !important;
}
::v-deep .rotate-circle {
  display: none !important;
}
::v-deep .tmap-zoom-control {
  display: none !important;
}
::v-deep .tmap-scale-control {
  display: none !important;
}
.dispatch-map {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  .map-box {
    flex: 1;
    overflow: hidden;
    position: relative;
    #container {
      width: 100%;
      height: 100%;
    }
    .map-center-box {
      position: absolute;
      left: 50%;
      bottom: 50%;
      transform: translateX(-50%);
      z-index: 9;
      display: flex;
      flex-direction: column;
      align-items: center;
      .chatting {
        box-sizing: border-box;
        // background: url('/src/assets/image/chatting.png') no-repeat left top;
        min-height: 40px;
        overflow: hidden;
        background: url('../../../assets/image/chatting.png') no-repeat left top;
        background-size: 100% 100%;
        padding: 10px 10px 16px 10px;
        font-size: 14px;
        word-break: keep-all;
        text-align: center;
      }
    }
    .prompt-dialog-box {
      // height: 32px;
      display: flex;
      align-items: center;
      font-size: 12px;
      line-height: 32px;
      color: #0093d0;
      background-color: #bfecff;
      padding-left: 20px;
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 9997;
      // .bottom {
      //   height: 8px;
      //   position: absolute;
      //   left: 0;
      //   right: 0;
      //   bottom: -8px;
      //   z-index: 9;
      //   background-color: #FFEAD8;
      // }
    }
    .position-phone {
      width: 35px;
      height: 35px;
      position: absolute;
      right: 10px;
      bottom: 50px;
      z-index: 3000;
      background-color: #fff;
      border-radius: 8px;
      display: flex;
      justify-content: center;
      align-items: center;
      .van-button {
        width: 20px;
        height: 20px;
        border: 2px solid #333;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        .dot {
          width: 10px;
          height: 10px;
          background-color: #333;
          border-radius: 50%;
        }
      }
    }
    .position-phone-active {
      .van-button {
        border-color: #4776e3;
        .dot {
          background-color: #4776e3;
        }
      }
    }
    .watch-position {
      position: absolute;
      z-index: 9;
      bottom: 50px;
      left: 50%;
      transform: translateX(-50%);
      background-color: #fff;
    }
  }
}
</style>